// extracted by mini-css-extract-plugin
module.exports = {"baseError":"_baseError__YgAAZ","imgWrapper":"_imgWrapper__vlY2o","linkify":"_linkify__spwVT","modal":"_modal__yBsrK"};